import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdBanner } from "interfaces/ad-banner.ts";

interface AdContestState {
  contestBanner: AdBanner | null;
}

const initialState: AdContestState = {
  contestBanner: null
};

const adContestSlice = createSlice({
  name: "adContest",
  initialState,
  reducers: {
    setContestBanner: (state, action: PayloadAction<AdBanner>) => {
      state.contestBanner = action.payload;
    },
    clearContestBanner: (state) => {
      state.contestBanner = null;
    }
  },
});

export const { setContestBanner, clearContestBanner } = adContestSlice.actions;

export default adContestSlice.reducer; 